var _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmountDebited(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 11.7324H3.2C1.424 11.7324 0.016 13.1564 0.016 14.9324L0 34.1324C0 35.9084 1.424 37.3324 3.2 37.3324H28.8C30.576 37.3324 32 35.9084 32 34.1324V14.9324C32 13.1564 30.576 11.7324 28.8 11.7324ZM27.2 34.1324H4.8C3.92 34.1324 3.2 33.4124 3.2 32.5324V24.5324H28.8V32.5324C28.8 33.4124 28.08 34.1324 27.2 34.1324ZM28.8 18.1324H3.2V16.5324C3.2 15.6524 3.92 14.9324 4.8 14.9324H27.2C28.08 14.9324 28.8 15.6524 28.8 16.5324V18.1324Z",
    fill: "#6F6AF8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.1992,
    y: 8.5332,
    width: 6.4,
    height: 7.46667,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 6.4L22.4008 -2.79753e-07L28.8008 6.4L27.6808 7.54L23.2008 3.06L23.2008 12.8L21.6008 12.8L21.6008 3.06L17.1208 7.54L16.0008 6.4Z",
    fill: "#6F6AF8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountDebited);
export default __webpack_public_path__ + "static/media/amount_debited.bd2dce4d192283ddb0dc7de305ac6a9d.svg";
export { ForwardRef as ReactComponent };